import { variables } from 'config';
import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  page: {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: `calc(100vh - 64px)`,
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.mainBackground,
    color: theme.palette.primary.main,
    textAlign: 'start',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
  },
  rootDrawerOpen: {
    maxWidth: `calc(100% - ${variables.drawerWidth} - 64px)`,
  },
  rootDrawerClose: {
    maxWidth: `calc(100% - ${variables.closedDrawerWidth} - 64px)`,
  },
  pageContent: {
    flex: '1 1 auto',
    position: 'relative',
    overflowY: 'auto',
    height: `calc(100vh - 64px)`,
    margin: '24px 24px 0 24px',
    backgroundColor: 'white',
    borderRadius: '4px',
    boxShadow: '0px 2px 8px rgb(0 0 0 / 5%)',
  },
  boxContainer: {
    borderRadius: '5px 5px 0 0',
    color: theme.palette.primary.sideBarTextColor,
    height: 'fit-content',
    boxShadow: 'none',
  },
  tabsHeader: {
    backgroundColor: theme.palette.primary.backgroundColor,
    color: 'black',
    boxShadow: '0 1px 0px #e4e4e4',
    marginBottom: 20,
  },
  fieldHeader: {
    display: 'flex',
  },
  fieldHeaderText: {
    marginRight: '10px',
    fontWeight: '600',
    fontSize: '18px',
    color: theme.palette.primary.sideBarTextColor,
  },
  menuPaper: {
    maxHeight: '450px',
  },
  tabForm: {
    fontWeight: '600',
  },
  tabFormInvalid: {
    color: '#f44336',
  },
  helperDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '19px',
  },
  qrHelperDiv: {
    display: 'flex',
    justifyContent: 'end',
    minHeight: '19px',
  },
  errorHelperText: {
    color: '#f44336',
    minHeight: '19px',
  },
  invalidSelectContainer: {
    border: '1px solid #f44336',
    borderRadius: '4px',
    '& > fieldset': {
      border: 'none',
    },
    '&:before': {
      borderBottom: '2px solid #f44336',
    },
    '&:after': {
      borderBottom: '2px solid #f44336',
    },
    '&:hover': {
      '&:before': {
        borderColor: '#f44336',
        borderBottomWidth: '2px',
      },
    },
  },
  chipHeader: {
    width: '100%',
    fontWeight: '500',
    fontSize: '12px',
    color: 'black',
    opacity: '0.6',
  },
  headerTitle: {
    fontWeight: '500',
    fontSize: '16px',
    color: theme.palette.primary.sideBarTextColor,
  },
  headerDescription: {
    fontWeight: '400',
    fontSize: '14px',
    color: theme.palette.primary.sideBarTextColor,
    opacity: '0.6',
  },
  leftPart: {
    padding: '0',
    backgroundColor: theme.palette.primary.backgroundColor,
  },
  content: {
    padding: '20px',
  },
  tagChip: {
    height: '24px',
  },
  disabledError: {
    color: 'red',
    marginLeft: '10px',
    fontSize: '14px',
  },
  optionItem: {
    '&[aria-disabled="true"]': {
      opacity: 1,
    },
  },
  tableRoot: {
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.sideBarBgColor,
    color: theme.palette.primary.main,
    flexGrow: 1,
    display: 'block',
    textAlign: 'start',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
  },
  container: {
    display: 'inherit',
  },
  tabsContainer: {
    width: '100%',
  },
  divider: {
    width: '100%',
    marginTop: '16px',
  },
  menuItemsMarginTop: {
    marginTop: '12px',
  },
  menuItemsArea: {
    marginTop: '16px',
  },
  chipRoot: {
    maxWidth: 'calc(100% - 40px)',
  },
  chipCount: {
    minWidth: 'fit-content',
    alignSelf: 'center',
    fontWeight: 500,
    fontSize: '16px',
  },
  wineChip: {
    height: 'auto',
    alignItems: 'center',
    maxWidth: 320,
  },
  wineChipLabel: {
    display: 'flex',
    flexDirection: 'column',
    px: 1,
    py: 0.75,
  },
  wineChipName: {
    fontSize: '0.78rem',
    lineHeight: 1.15,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wineChipMeta: {
    fontSize: '0.66rem',
    lineHeight: 1,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wineOptionRow: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  wineOptionText: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
  },
  wineOptionName: {
    fontSize: '0.925rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wineOptionMeta: {
    fontSize: '0.78rem',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  menuItemsEmptyRoot: {
    width: '100%',
    alignSelf: 'center',
    color: theme.palette.primary.notActiveIconColor,
    minHeight: '342px',
    fontFamily: 'Montserrat, sans-serif',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  iconHeader: {
    width: '100%',
  },
  wineIcon: {
    width: '200px',
    height: '200px',
  },
  emptyPageTitle: {
    marginTop: '20px',
    fontSize: '16px',
    fontWeight: '400',
  },
  select: {
    marginTop: '0px',
    border: 'none',
    width: '100%',
    height: '56px',
    boxShadow: 'none',
    textAlign: 'left',
  },
  selectHeight: {
    '& .MuiInput-root': {
      marginTop: '0px',
    },
  },
  sectionHeaderText: {
    fontWeight: '600',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.sideBarTextColor,
  },
  fieldDescription: {
    margin: '16px 0 0 0',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16px',
  },
  checkboxLabel: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0px',
    fontWeight: '600',
  },
  showTableOrWineNumberSwitch: {
    fontWeight: '600',
    fontSize: '16px',
  },
  fieldHeaderIcon: {
    color: theme.palette.primary.sideBarIconColor,
    opacity: '0.6',
    cursor: 'pointer',
    marginLeft: '2px',
    fontSize: '1.2rem',
    verticalAlign: 'middle',
  },
  shouldResetWineRating: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fieldHeaderWithTooltip: {
    display: 'flex',
    alignItems: 'center',
  },
  dragIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  pageFooter: {
    boxShadow: '0px -2px 16px rgba(0, 0, 0, 0.05)',
    zIndex: 1,
    textTransform: 'none',
  },
  footerPart: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '84px',
    backgroundColor: 'white',
    alignContent: 'center',
    padding: '0 32px 0 24px',
    minWidth: '416px',
    '& > button': {
      textTransform: 'none',
      margin: '0 0 0 20px',
    },
  },
  personalizationSection: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  lockIcon: {
    marginLeft: theme.spacing(1),
    fontSize: '18px',
    verticalAlign: 'middle',
    color: theme.palette.grey[500],
    '&:hover': {
      cursor: 'pointer',
      borderColor: 'rgba(0, 0, 0)',
    },
  },
  noAccess: {
    fontSize: '14px',
    color: theme.palette.primary.sideBarIconColor,
    textAlign: 'center',
    padding: '8px',
    backgroundColor: 'white',
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  redLink: {
    color: theme.palette.primary.error,
    cursor: 'pointer',
  },
  applyToAllButton: {
    textTransform: 'none',
    marginTop: '16px',
    fontSize: '0.875rem',
    fontFamily: 'unset',
  },
  menuWinesTableCell: {
    padding: '16px',
    '@media (max-width: 1400px)': {
      padding: '16px 8px',
    },
  },
};
